import { getHeaders } from 'src/api/headers'
import { ins } from 'src/api/axios'

export const soundAlarm = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/alarm/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const lockVehicle = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/lock/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const openBatteryHatch = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/open-battery/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const unlockVehicle = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/unlock/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const rebootCCU = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/reboot-ccu/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const rebootIOT = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/reboot-iot/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const updateVersion = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/update-firmware/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const takeOwnership = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/take-ownership/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const setVehicleStatus = async (vehicleId: string, status: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/status/${vehicleId}`)
    const headers = await getHeaders()
    const formData = new FormData()
    formData.append('status', status)

    const { 'Content-Type': _, ...headersWithoutContentType } = headers

    return ins
        .patch(link, formData, { headers: headersWithoutContentType })
        .then(result => result)
        .catch(error => {
            throw error
        })
}

export const giveUpOwnership = async (vehicleId: string): Promise<any> => {
    const link = encodeURI(`/v1/fm/vehicles/give-up-ownership/${vehicleId}`)
    const headers = await getHeaders()
    return ins
        .patch(link, {}, { headers })
        .then(result => result)
        .catch(error => {
            throw error
        })
}
